import { render, staticRenderFns } from "./giveLog.vue?vue&type=template&id=b819f922&scoped=true"
import script from "./giveLog.vue?vue&type=script&lang=js"
export * from "./giveLog.vue?vue&type=script&lang=js"
import style0 from "./giveLog.vue?vue&type=style&index=0&id=b819f922&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b819f922",
  null
  
)

export default component.exports